// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"495f45ed","63":"146b5674","239":"0176389a","455":"b9b58644","609":"d8aa4b90","977":"faf1d57e"}[chunkId] + ".chunk.js";
};